/* eslint-disable prettier/prettier */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable consistent-return */
/* eslint-disable no-plusplus */
/* eslint-disable react/react-in-jsx-scope */
// Adicione no início do arquivo
import { useState, useEffect, useRef, useCallback } from 'react'
import { IconButton, Tooltip } from '@material-ui/core'
import { VisibilityOff, Visibility } from '@material-ui/icons'
import api from '../../../../services/api'



export default function TranscriptionButton({ room, sessionId, userName, classes, ws}) {
  const [showTranscript, setShowTranscript] = useState(false)
  const [transcript, setTranscript] = useState('')
  const [isFinal, setIsFinal] = useState(false)
  const transcriptContainerRef = useRef<HTMLDivElement>(null)
 
  useEffect(() => {
    if (!ws) return

    ws.onmessage = event => {
      const data = JSON.parse(event.data)
      console.log(data)
      if (data.type === 'transcript' && data.text) {
        setTranscript(prev => `${prev}\n${data.userName}: ${data.text}`)
      }
    }

    ws.onerror = err => {
      console.error('Erro no WebSocket de transcrição:', err)
    }

    return () => {
      // Não feche o ws aqui, pois ele é gerenciado pelo ToolBar
    }
  }, [ws])

  useEffect(() => {
    if (transcriptContainerRef.current) {
      transcriptContainerRef.current.scrollTop = transcriptContainerRef.current.scrollHeight
    }
  }, [transcript])



  return (
    <>
      <Tooltip title={showTranscript ? 'Ocultar legenda' : 'Mostrar legenda'}>
        <IconButton
          edge="start"
          color="inherit"
          className={classes.toolbarButtons}
          onClick={() => setShowTranscript(!showTranscript)}
        >
          {showTranscript ? <Visibility /> : <VisibilityOff />}
        </IconButton>
      </Tooltip>
      
      {/* Área de exibição da transcrição (legenda) */}
      {showTranscript && transcript && (
        <div className={classes.transcriptPreview} ref={transcriptContainerRef}>
          {transcript.split('\n').map((line, index) => (
            <div
              key={index}       
              style={{ 
                opacity: index === transcript.split('\n').length - 1 && !isFinal ? 0.7 : 1,
                fontWeight: index === transcript.split('\n').length - 1 && !isFinal ? 'normal' : 'bold',
                padding: '2px 0'
              }}    
            >
              {line}
            </div>
          ))}
        </div>
      )}
    </>
  )
}